let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("Wowvf"), load("2yM8Y")]).then(() => parcelRequire('kIWbA'));